import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card as MuiCard
} from 'material-ui/Card';
import { Row, Col } from 'react-flexbox-grid';
import Icon, { NAMES } from '@ifit/react-icons';
import { scienceBlue, shark } from '../../../../theme/colors';

import './index.css';

class ConnectFilterCard extends Component {
  render() {
    const { onClick, title, subtitle } = this.props;
    return (
      <div className="connect-filter-card-component">
        <MuiCard
          style={{ borderRadius: '4px' }}
          onClick={ onClick }
        >
          <div className="card-content">
            <Row>
              <Col xs={ 12 }>
                <h4 key="access-to-equipment-bool">
                  { title }
                </h4>
                <div className="arrow">
                  <Icon name={ NAMES.ARROW_RIGHT_LONG } color={ scienceBlue } size={ 24 } />
                </div>
              </Col>
            </Row>
            <Row>
              { subtitle &&
                <Col xs={ 12 }>
                  <p>
                    { this.props.subtitle }
                  </p>
                </Col>
              }
            </Row>
            { subtitle &&
            <Row center="xs" className="compatible-icons">
              <Col xs>
                <Icon name={ NAMES.WEARABLE } color={ shark } size={ 24 } />
                <span>Wearable</span>
              </Col>
              <Col xs>
                <Icon name={ NAMES.PHONE } color={ shark } size={ 24 } />
                <span>Phone Only</span>
              </Col>
            </Row>
            }
          </div>
        </MuiCard>
      </div>
    );
  }
}

ConnectFilterCard.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string
};

export default ConnectFilterCard;
